import { render, staticRenderFns } from "./SubmissionIdModal.vue?vue&type=template&id=67400f77&"
import script from "./SubmissionIdModal.vue?vue&type=script&lang=ts&"
export * from "./SubmissionIdModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports